import styled from '@emotion/styled';

import { breakpoints, colors } from '@datacamp/waffles-tokens';

import imageSwoosh from 'images/cta/swoosh.png';

export const Text = styled.h3`
  font-size: 41px; /* DS violation to match Zeplin */
  margin: 0 0 24px 0;
  padding: 0 16px; /* DS violation to match Zeplin */

  @media screen and (min-width: ${breakpoints.xs}) {
    font-size: 50px; /* DS violation to match Zeplin */
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    margin: 0 auto 24px;
    max-width: 590px;
    padding: 0;
  }
`;

export const Wrapper = styled.article`
  background-image: url(${imageSwoosh}),
    linear-gradient(to bottom, ${colors.porcelain}, ${colors.white});
  background-position: center bottom, 0;
  background-repeat: no-repeat;
  background-size: auto 550px, cover;
  margin-top: 80px;
  padding-bottom: 156px; /* DS violation to match Zeplin */
  text-align: center;

  @media screen and (min-width: ${breakpoints.md}) {
    align-items: center;
    background-position: calc(50% + 80px) center, 0; /* 585 is half the container */
    background-size: auto 90%, cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 512px; /* matching the Zeplin */
    padding: 16px;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    margin-top: 16px;
  }
`;
